import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Loader } from 'kepler';
import _ from 'lodash';
import AccordionTopicGroup from '../components/AccordionTopicGroup';
import ErrorPanel from '../components/ErrorPanel';
import i18n from '../../lib/reacti18n';
import Page from '../../lib/page';
import Breadcrumb from '../containers/Breadcrumb';
import { TOPIC } from '../constants/PropTypesShapes';

const exp = Page.getUserExperience();
const label = i18n.message(`smarthelp/contentToggle.content.label.desktop.${exp}`);
const maxbcLength = 3;

const ArticleList = (props) => {
  const { articleList, breadcrumb } = props;

  const getActiveTopic = () => {
    let selectedArticle;
    if (breadcrumb && breadcrumb.length && (breadcrumb.length === maxbcLength || Page.isMobileLayout())) {
      selectedArticle = _.find(articleList.articleList, article => (breadcrumb[breadcrumb.length - 1].id === article.id));
    }
    return selectedArticle || articleList.articleList[0];
  };
  const renderArticleList = () => {
    if (!articleList.articleList) {
      return null;
    }
    const options = { name: 'home' };
    Page.setCanonicalTag(options);
    const topics = articleList;
    return <AccordionTopicGroup topics={topics} activeTopic={getActiveTopic()} />;
  };

  const renderContents = () => {
    if (articleList.isLoading) {
      return <Loader size="lg" show type="fixed" />;
    } else if (articleList.error) {
      return <ErrorPanel />;
    }
    return renderArticleList();
  };

  const getBreadcrumbItems = () => (
    !articleList.error ? [{
      path: `/${exp}/home`,
      title: label,
    }] : []
  );
  return (
    <div className="topic-articlelist-container">
      <Breadcrumb items={getBreadcrumbItems()} />
      <div className="topic-title">{articleList.articleTitle}</div>
      <div className="contents">
        { renderContents() }
      </div>
    </div>
  );
};


function mapStateToProps(state) {
  return {
    articleList: state.articleList,
    breadcrumb: state.breadcrumb.items,
  };
}

ArticleList.propTypes = {
  articleList: PropTypes.shape({
    isLoading: PropTypes.bool.isRequired,
    error: PropTypes.bool,
    articleList: PropTypes.arrayOf(PropTypes.shape(TOPIC)),
  }).isRequired,
  breadcrumb: PropTypes.arrayOf({
    id: PropTypes.string,
    title: PropTypes.string,
    path: PropTypes.string,
  }),
};

ArticleList.defaultProps = {
  breadcrumb: [],
};

export default connect(mapStateToProps)(ArticleList);



// WEBPACK FOOTER //
// ./home/containers/ArticleListByTopic.js